module.exports = __webpack_public_path__ + "img/sg_colour.317b1c26.webp";